export default __webpack_public_path__ + "static/media/logo-extendido.af1aeb81.svg";